import { render, staticRenderFns } from "./ActiveListDetailSpoc.vue?vue&type=template&id=f837f316&scoped=true&"
import script from "./ActiveListDetailSpoc.vue?vue&type=script&lang=js&"
export * from "./ActiveListDetailSpoc.vue?vue&type=script&lang=js&"
import style0 from "./ActiveListDetailSpoc.vue?vue&type=style&index=0&id=f837f316&lang=scss&scoped=true&"
import style1 from "./ActiveListDetailSpoc.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f837f316",
  null
  
)

export default component.exports